import { FormField } from 'taboola-ultimate-ui';
import { OutlineEditableText } from 'modules/campaigns/components';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './setupClicksEventCategory.module.scss';

export const MAX_CONVERSION_NAME_LENGTH = 20;

export const ConversionNameField = ({ conversionName, onConversionNameChange }) => {
    return (
        <FormField
            required
            containerClass={styles['name-input-container']}
            inputId="conversionName"
            label={<FormattedMessage id="codeless.setup.conversion.name.label" defaultMessage="Conversion Name" />}
        >
            <OutlineEditableText
                id="conversionName"
                className={styles['name-input']}
                value={conversionName}
                onChange={onConversionNameChange}
                maxLength={MAX_CONVERSION_NAME_LENGTH}
            />
        </FormField>
    );
};
